type VideoMetadata = {
	width: number;
	height: number;
	durationSec: number;
};

const readVideoMetadata = (src: string): Promise<VideoMetadata> =>
	new Promise((resolve, reject) => {
		const video = document.createElement("video");
		video.preload = "metadata";
		video.onloadedmetadata = () => {
			resolve({
				width: video.videoWidth,
				height: video.videoHeight,
				durationSec: video.duration,
			});
			video.removeAttribute("src");
			video.load();
		};
		video.onerror = () => reject(new Error("Failed to load video metadata"));
		video.src = src;
	});

export const readVideoMetadataFromUrl = (url: string): Promise<VideoMetadata> =>
	readVideoMetadata(url);

/** Read duration/dimensions from a local File before upload begins. */
export const readVideoMetadataFromFile = (
	file: File,
): Promise<VideoMetadata> => {
	const objectUrl = URL.createObjectURL(file);
	return readVideoMetadata(objectUrl).finally(() => {
		URL.revokeObjectURL(objectUrl);
	});
};

export const readImageDimensionsFromUrl = (
	url: string,
): Promise<{ width: number; height: number }> =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.onload = () => {
			resolve({ width: image.naturalWidth, height: image.naturalHeight });
		};
		image.onerror = () => reject(new Error("Failed to load image dimensions"));
		image.src = url;
	});
